<template>
  <a-range-picker
    style="width: 100%"
    name="time_range"
    format="YYYY-MM-DD HH:mm:ss"
    @change="handleChange"/>
</template>

<script>
export default {
  name: 'SelectTime',
  data () {
    return {
      values: [],
      value: { isNull: true }
    }
  },

  methods: {
    handleChange (value, timeString) {
      if (timeString.length == 0) {
        this.value.isNull = true
        return
      }
      this.value.isNull = false
      const time = {
        from: timeString[0],
        to: timeString[1],
        isNull: false
      }
      this.value = time
      this.$emit('search_condition_changed')
    }

  }
}
</script>
